import React from 'react';

export const CalendarIcon = ({ size = 16, color = '#007E47' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size + 1} height={size} viewBox="0 0 17 16" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.51855 2.13293H15.7227V13.6932C15.7227 14.3163 15.2177 14.8214 14.5946 14.8214H2.64669C2.02364 14.8214 1.51855 14.3163 1.51855 13.6932V2.13293ZM2.51855 3.13293V13.6932C2.51855 13.764 2.57592 13.8214 2.64669 13.8214H14.5946C14.6654 13.8214 14.7227 13.764 14.7227 13.6932V3.13293H2.51855Z"
      fill={color}
    />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.6084 3.71132V1.17358H5.6084V3.71132H4.6084Z" fill={color} />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.6328 3.71132V1.17358H12.6328V3.71132H11.6328Z"
      fill={color}
    />
    <path d="M3.9248 10.1212H5.92019V12.1166H3.9248V10.1212Z" fill={color} />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.0711 5.0896H2.39551V4.0896H15.0711V5.0896Z" fill={color} />
  </svg>
);



// WEBPACK FOOTER //
// ./src/assets/icons/Calendar.incon.jsx